import Header from "./header";
import Footer from "./footer";
import Top from "./top";
import { useAppContext } from "context/AppContext";

type LayoutProps = {
    children: React.ReactNode;
    subdomain: string;
};

const Layout = ({ children, subdomain }: LayoutProps) => {
    const { isApp } = useAppContext();

    if (!subdomain) return null;
    return (
        <>
            <div className="flex flex-col relative min-h-[100dvh]">
                {!isApp && (
                    <div className="fixed top-0 left-0 w-full z-50 bg-white">
                        <Header subdomain={subdomain} />
                    </div>
                )}

                {children}
                {!isApp && <Footer />}

                <div className="fixed right-16 bottom-10 z-50 responsive1200:right-5">
                    <Top />
                </div>
                <div id="drawer-root"></div>
            </div>
        </>
    );
};

export default Layout;
